import request from '@/utils/requestUtil'

export function memberLogin(data) {
  return request({
    method: 'POST',
    url: '/sso/login',
    header: {
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  })
}

export function memberInfo() {
  return request({
    method: 'GET',
    url: '/sso/info'
  })
}

export function updatePassword(data) {
  return request({
    method: 'POST',
    url: '/sso/updatePassword',
    header: {
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  })
}

export function getCaptcha() {
  return request({
    method: 'GET',
    url: '/sso/captcha'
  })
}

export function getAuthCode(telephone, type) {
  return request({
    method: 'GET',
    url: '/sso/getAuthCode',
    params: {
      telephone,
      type
    }
  })
}

export function getLogoutAuthCodeApi(params) {
  return request({
    method: 'GET',
    url: '/sso/getLogoutAuthCode',
    params
  })
}

export function register(data) {
  return request({
    method: 'POST',
    url: '/sso/register',
    header: {
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  })
}

export function createMessageApi(data) {
  return request({
    method: 'POST',
    url: '/messageBoard/create',
    data
  })
}

export function uploadImage(data) {
  return request({
    method: 'POST',
    url: '/sso/uploadImage',
    data: data
  })
}

export function submitAgentInfo(data) {
  return request({
    method: 'POST',
    url: '/sso/submitAgentInfo',
    data: data
  })
}

export function validatePhoneAndUserName(data) {
  return request({
    method: 'POST',
    url: '/sso/validatePhoneAndUserName',
    header: {
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  })
}

export function getResetPwdAuthCode(data) {
  return request({
    method: 'POST',
    url: '/sso/getResetPwdAuthCode',
    header: {
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  })
}

export function resetPassword(data) {
  return request({
    method: 'POST',
    url: '/sso/resetPassword',
    header: {
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  })
}

export function checkUserNameApi(data) {
  return request({
    method: 'POST',
    url: '/sso/checkUsername',
    data
  })
}

export function checkPhoneApi(data) {
  return request({
    method: 'POST',
    url: '/sso/checkPhone',
    data
  })
}

export function logoutApi(data) {
  return request({
    method: 'POST',
    url: '/sso/logout',
    data
  })
}
